import { SharingData } from '../../schema/SharingData';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';

export function isUnshareable(sharingData: SharingData): boolean {
    return (
        sharingData.sharingInfo?.getSharingInfoSucceeded &&
        !sharingData.sharingInfo.canShareInternally &&
        (sharingData.currentPermissionLevel === AttachmentPermissionLevel.Edit ||
            sharingData.currentPermissionLevel === AttachmentPermissionLevel.View)
    );
}
